import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Responsive, GET_LIST, translate } from 'admin-on-rest';
import { Table, TableBody, TableHeaderColumn, TableHeader, TableRow, TableRowColumn } from 'material-ui/Table';
import Chip from 'material-ui/Chip';
import {blue300 } from 'material-ui/styles/colors';
import styled from 'styled-components';
import FlatButton from 'material-ui/FlatButton';
import {RestClient} from '../restClient';
import CurrencyField from '../components/CurrencyField';


class MarketerSales extends Component{
  constructor(props){
    super(props);
    this.state = {
      itemSales : []
    }
    this.loadSales();
  }
  loadSales = () =>{
    let url = 'marketers/'+this.props.idMarketer+'/sales';
    const options = { pagination: { page: 1, perPage: 100 }, sort: { field: 'created_at', order: 'DESC' }};
    RestClient(GET_LIST, url,options)
    .then((items) => {
      this.setState({
          itemSales:items.data
      })
    })
    .catch((e) => {
      // console.error(e);
    });
  }

  renderNameProduct = (item, index) =>{
    return(
      <span key={index} ><Chip style={{ margin: 4}} backgroundColor={blue300}>{item.name}</Chip> </span>
    )
  }
  
  checkUrl = (url) => {
    return 'https://ola.id/orders/'+url;
  }

  renderSalesFields = (item, index) => {
    const date = item.created_at instanceof Date ? item.created_at : new Date(item.created_at);
    const dateString = date.toLocaleDateString();
    return(
      <TableRow key={index} >
        <TableRowColumn style={{paddingLeft: 16, paddingRight:16}}>
          <FlatButton label={item.ref} primary={true} href={this.checkUrl(item.ref)} target='_blank' />
        </TableRowColumn >
        <TableRowColumn style={{paddingLeft: 16, paddingRight:16}}>
          <ContainerName>
            {(item.items.length > 0) && item.items.map(this.renderNameProduct)}
          </ContainerName>
        </TableRowColumn>
        <TableRowColumn style={{paddingLeft: 16, paddingRight:16}}>
          {item.status}
        </TableRowColumn >
        <TableRowColumn style={{width: 100,paddingLeft: 16, paddingRight:16}}>
          <CurrencyField
            hintText="Amount"
            underlineShow={false}
            precision={0}
            separator=""
            delimiter="."
            value={item.amounts.total}
            unit="Rp"
          />
        </TableRowColumn>
        <TableRowColumn  style={{width: 80,paddingLeft: 16, paddingRight:16}}>
          {dateString}
        </TableRowColumn>
      </TableRow>
    )
  }
  renderSalesFieldsSmall = (item,index) => {
    const {translate} = this.props;
    const date = item.created_at instanceof Date ? item.created_at : new Date(item.created_at);
    const dateString = date.toLocaleDateString();
    return (
      <TableRow key={index} >
        <TableRowColumn >
          <ItemBoxSmall>
            <ContainerText>{translate("resources.marketers.sales.ref")}</ContainerText>
            <div><FlatButton label={item.ref} primary={true} href={this.checkUrl(item.ref)} target='_blank' /></div>
          </ItemBoxSmall>
          <ItemBoxSmall>
            <ContainerText>{translate("resources.marketers.sales.product")}</ContainerText>
            <div>
              <ContainerName>
                {(item.items.length > 0) && item.items.map(this.renderNameProduct)}
              </ContainerName>
            </div>
          </ItemBoxSmall>
          <ItemBoxSmall>
            <div>{translate("resources.marketers.sales.status")}</div>
            <div>{item.status}</div>
          </ItemBoxSmall>
          <ItemBoxSmall>
            <div style={{ marginVertical: 10}}>{translate("resources.marketers.sales.amount")}</div>
            <div>
              <CurrencyField
                hintText="Price"
                underlineShow={false}
                precision={0}
                separator=""
                delimiter="."
                value={item.amounts.total}
                unit="Rp"
              />
            </div>
          </ItemBoxSmall>
          <ItemBoxSmall>
            <div>{translate("resources.marketers.sales.create_at")}</div>
            <div>{dateString}</div>
          </ItemBoxSmall>
        </TableRowColumn>
      </TableRow>
    )
  }
  render(){
    const {translate} = this.props;
    return (
      <div>
        <Responsive
          small={<Table   selectable={false}>
            <TableBody displayRowCheckbox={false}>
              >{(this.state.itemSales.length > 0)  && this.state.itemSales.map(this.renderSalesFieldsSmall)}
            </TableBody>
          </Table>}
          medium={<Table   selectable={false}>
            <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
              <TableRow>
               <TableHeaderColumn>{translate("resources.marketers.sales.ref")}</TableHeaderColumn>
                <TableHeaderColumn>{translate("resources.marketers.sales.product")}</TableHeaderColumn>
                <TableHeaderColumn>{translate("resources.marketers.sales.status")}</TableHeaderColumn>
                <TableHeaderColumn style={{width: 100}}>{translate("resources.marketers.sales.amount")}</TableHeaderColumn>
                <TableHeaderColumn style={{width: 80}}>{translate("resources.marketers.sales.create_at")}</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              >{(this.state.itemSales.length > 0)  && this.state.itemSales.map(this.renderSalesFields)}
            </TableBody>
          </Table>} />
      </div>)
  }
}

const ContainerName = styled.div`
  display: flex;
 flex-wrap: wrap;
`;
const ContainerText = styled.div`
  margin-left: 0;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`;
const ItemBoxSmall = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 8px;
`;

MarketerSales.propTypes = {
  idMarketer: PropTypes.number,
  translate:PropTypes.func
};

export default translate(MarketerSales);



// WEBPACK FOOTER //
// ./src/marketers/MarketerSales.js